import { FeatureHubResponse, Features } from './constants'

export function mapFeatures(res: FeatureHubResponse): Features {
  let features: Partial<Features> = {}
  res[0].features.forEach((f) => {
    const key = f.key as keyof Features
    features = { ...features, [key]: f.value }
  })

  return features as Features
}
